import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { HttpClient } from '@angular/common/http';
import { ApiUrlConstants } from 'src/app/common/constants/api.constants';
import { catchError } from 'rxjs/internal/operators';
import { Observable } from 'rxjs/Observable';
import { StorePortal } from '../interfaces/store-config.interface';

@Injectable({ providedIn: 'root' })
export class StorePortalService {

    constructor(private httpClient: HttpClient,
        private _cacheService: CacheService) { }

    /**
   * To get Store portal mappings by Id
   * @returns Observable
   */
    getStorePortals(storeId: number): Promise<StorePortal[]> {
        const getStorePortals = ApiUrlConstants.configurationApiUrl + 'stores/' + storeId + '/portals';
        return this.httpClient
            .get<StorePortal[]>(decodeURIComponent(encodeURIComponent(getStorePortals)))
            .pipe(catchError(this.handleErrorObservable)).toPromise();
    }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }
}